// extracted by mini-css-extract-plugin
export default {"continueBtn":"SimpleTheme_continueBtn__V5PrB"};